<mat-card class="summary-card">

  <div class="header">
    <mat-icon>description</mat-icon>
    <span>Resumen del producto</span>
  </div>

  <mat-divider></mat-divider>

  <div class="section">
    <div><strong>Activado:</strong> <span *ngIf="product?.enabled">Sí</span><span *ngIf="!product?.enabled">No</span></div>
    <div><strong>Tamaño:</strong> {{ category?.code }}</div>
    <div><strong>Canal:</strong> {{ product?.channel|traduccion }}</div>
  </div>

  <mat-divider></mat-divider>

  <div class="section">
    <div class="title">Precios activos:</div>

    <ul class="price-list">
      <li *ngFor="let price of product?.prices">
        {{ price.price }}€/{{ price.period }} {{ getUnitLabel(price.unit) }}
        ({{ price.minPeriod }}-{{ price.maxPeriod }} {{ getUnitLabel(price.unit) }}s)
      </li>
    </ul>
  </div>

</mat-card>